import React from 'react';
import { Modal, Button, Table, Tooltip, Typography, Space } from 'antd';
import { MessageOutlined, AmazonOutlined } from '@ant-design/icons';

const { Text } = Typography;

const SendFollowUpMessageModal = ({ visible, onCancel, onConfirm, overdueOrders, loading }) => {
    const columns = [
        {
            title: '#',
            key: 'index',
            width: 50,
            align: 'center',
            render: (_, record, index) => (
                <Text style={{ fontSize: 12, fontWeight: 'bold' }}>{index + 1}</Text>
            )
        },
        {
            title: 'Order ID',
            dataIndex: 'amazonOrderId',
            key: 'amazonOrderId',
            width: 190,
            render: (text) => (
                <Space>
                    <AmazonOutlined style={{ color: '#FF9900', fontSize: 12 }} />
                    <Text style={{ fontSize: 12 }}>{text}</Text>
                </Space>
            )
        },
        {
            title: 'Order Item ID',
            dataIndex: 'orderItemId',
            key: 'orderItemId',
            width: 160,
            render: (text) => <Text style={{ fontSize: 12 }}>{text}</Text>
        },
        {
            title: 'SKU',
            dataIndex: 'sellerSKU',
            key: 'sellerSKU',
            width: 270,
            render: (text) => <Text style={{ fontSize: 12, fontFamily: 'monospace' }}>{text}</Text>
        },
        {
            title: 'Product Name',
            dataIndex: 'title',
            key: 'title',
            ellipsis: true,
            render: (text) => (
                <Tooltip title={text}>
                    <Text style={{ fontSize: 12 }}>{text}</Text>
                </Tooltip>
            )
        },
        {
            title: 'Customer',
            dataIndex: 'customerName',
            key: 'customerName',
            width: 140,
            render: (text) => <Text style={{ fontSize: 12 }}>{text}</Text>
        },
        {
            title: 'Days Since Mockup',
            dataIndex: 'daysSinceMockup',
            key: 'daysSinceMockup',
            width: 120,
            align: 'center',
            render: (days) => (
                <Text style={{ 
                    fontSize: 12, 
                    fontWeight: 'bold',
                    color: days > 7 ? '#ff4d4f' : days > 3 ? '#fa8c16' : '#52c41a'
                }}>
                    {days} days
                </Text>
            )
        }
    ];

    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <MessageOutlined style={{ color: '#fa8c16' }} />
                    <span>Send Follow-up Message</span>
                </div>
            }
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={loading}>
                    Cancel
                </Button>,
                <Button 
                    key="submit"
                    type="primary" 
                    icon={<MessageOutlined />}
                    onClick={onConfirm}
                    loading={loading}
                    style={{ backgroundColor: '#fa8c16', borderColor: '#fa8c16' }}
                >
                    Send Follow-up Message
                </Button>
            ]}
            width='70%'
            styles={{
                body: {
                    padding: '24px'
                }
            }}
        >
            <div style={{ marginBottom: 16 }}>
                <Text>Are you sure you want to send follow-up message for the following overdue order items?</Text>
                <br />
                <Text type="secondary">This will send a reminder message to customers asking them to confirm their mockup.</Text>
            </div>
            
            <Table
                dataSource={overdueOrders}
                rowKey="id"
                pagination={false}
                size="small"
                columns={columns}
                scroll={{ y: 400 }}
            />
            
            <div style={{ marginTop: 16, padding: 12, backgroundColor: '#fff7e6', borderRadius: 6 }}>
                <Text strong style={{ color: '#fa8c16' }}>
                    Selected Items: {overdueOrders.length}
                </Text>
            </div>
        </Modal>
    );
};

export default SendFollowUpMessageModal;
